import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { setupHistoryUrlSync } from './store/historyUrlSync';
import './styles/tokens.css';
import './styles/global.css';

// Wire store↔URL sync once, outside React. Prevents render-loop hazards
// from useEffect-based URL writes.
setupHistoryUrlSync();

const root = document.getElementById('app');
if (!root) throw new Error('Missing #app root element');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
